module.exports = __webpack_public_path__ + "img/lanril.f07dd17c.png";